export function getNavOffset() {
  const navContainer = document.querySelector('header#shopify-section-header');
  return navContainer?.offsetHeight ?? 0;
};

export const smoothScroll = (element, offset) => {
  if (!element) return;
  const navOffset = getNavOffset();
  const scrollOffset = offset ?? navOffset;
  const top = element.getBoundingClientRect().top + window.scrollY - scrollOffset - 50;

  window.scrollTo({ top, behavior: 'smooth' });
};

const handleSmoothScroll = () => {
  const target = window.location.hash
  if (!target) return;
  window.location.hash = ""
  const element = document.querySelector(target);
  smoothScroll(element)
}

export default function initSmoothScroll() {
  window.addEventListener("hashchange", function () {
    if (window.location.hash === "") return false;
    handleSmoothScroll();
  });

  window.addEventListener("load", handleSmoothScroll);
}

initSmoothScroll();